import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.SET_FOLLOWED_PROJECTS]: (state, items) => state.items = items,
    [types.ADD_OR_UPDATE_FOLLOWED_PROJECT]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_FOLLOWED_PROJECT]: (state, item) => removeItem(state, item)
}
